var Jt = Object.defineProperty, Qt = Object.defineProperties;
var Wt = Object.getOwnPropertyDescriptors;
var bt = Object.getOwnPropertySymbols;
var Et = Object.prototype.hasOwnProperty, At = Object.prototype.propertyIsEnumerable;
var qt = (e, t, r) => t in e ? Jt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, xt = (e, t) => {
  for (var r in t || (t = {}))
    Et.call(t, r) && qt(e, r, t[r]);
  if (bt)
    for (var r of bt(t))
      At.call(t, r) && qt(e, r, t[r]);
  return e;
}, wt = (e, t) => Qt(e, Wt(t));
var L = (e, t) => {
  var r = {};
  for (var s in e)
    Et.call(e, s) && t.indexOf(s) < 0 && (r[s] = e[s]);
  if (e != null && bt)
    for (var s of bt(e))
      t.indexOf(s) < 0 && At.call(e, s) && (r[s] = e[s]);
  return r;
};
var ht = (e, t, r) => new Promise((s, n) => {
  var p = (o) => {
    try {
      d(r.next(o));
    } catch (m) {
      n(m);
    }
  }, a = (o) => {
    try {
      d(r.throw(o));
    } catch (m) {
      n(m);
    }
  }, d = (o) => o.done ? s(o.value) : Promise.resolve(o.value).then(p, a);
  d((r = r.apply(e, t)).next());
});
import { e as B, s as G, j as y, c as A, x as _, i as Xt, u as nt, l as Dt } from "./formik-field-3c206abb.js";
import { useRef as E, useEffect as C, useImperativeHandle as M, useCallback as D, useMemo as Gt } from "react";
import { c as Yt } from "./carousel.messages-243a8ce8.js";
const h = (e, t = !1) => {
  if (!(!e && !t))
    return e != null ? e : t;
};
function Mt(e) {
  const t = E();
  return C(() => {
    t.current = e;
  }, [e]), t.current;
}
function tt({ elementRef: e, onRef: t }) {
  C(() => {
    e != null && e.current && t && t(e);
  }, [e, t]);
}
function J({
  elementRef: e,
  eventName: t,
  eventCallback: r,
  emitter: s
}) {
  C(() => {
    const n = e == null ? void 0 : e.current;
    return s && s.on(t, r), n && n.addEventListener(t, r), () => {
      s && s.off(t), n && n.removeEventListener(t, r);
    };
  }, [e, s, r, t]);
}
const Vt = (b) => {
  var f = b, {
    "data-o2-id": e,
    "data-o2-portlet": t,
    "data-o2-role": r,
    "data-testid": s,
    children: n,
    className: p,
    closable: a,
    color: d,
    emitter: o,
    heading: m,
    id: u,
    inline: v,
    o2Ref: x,
    onHide: c,
    preventClose: l,
    slot: N,
    style: w
  } = f, g = L(f, [
    "data-o2-id",
    "data-o2-portlet",
    "data-o2-role",
    "data-testid",
    "children",
    "className",
    "closable",
    "color",
    "emitter",
    "heading",
    "id",
    "inline",
    "o2Ref",
    "onHide",
    "preventClose",
    "slot",
    "style"
  ]);
  const { styleProps: P } = B(g), i = G(P), j = E();
  M(
    x,
    () => j.current ? j.current : void 0,
    []
  );
  const R = D(() => {
    c == null || c();
  }, [c]);
  return J({
    elementRef: j,
    eventName: "o2Hide",
    eventCallback: R,
    emitter: o
  }), C(() => {
    if (d === "danger") {
      if (!t)
        throw new Error(
          'Alert component requires "data-o2-portlet" attribute (portlet name) when Alert color is "danger".'
        );
      if (!r)
        throw new Error(
          'Alert component requires "data-o2-role" attribute ("alert-system" for system errors like http 5xx server error, "alert-application" for application errors like user does not have access to requested resources or "alert-user" for errors caused by incorrect user input like incorrect form data) when Alert color is "danger".'
        );
    }
  }, [d, t, r]), /* @__PURE__ */ y.jsx(
    "o2-alert",
    {
      ref: j,
      id: u,
      "data-testid": s,
      class: A(p, i),
      "data-o2-id": e,
      "data-o2-portlet": t,
      "data-o2-role": r,
      closable: h(a),
      color: d,
      heading: m,
      "prevent-close": l,
      inline: h(v),
      slot: N,
      style: w,
      children: n
    }
  );
}, Ot = (u) => {
  var v = u, {
    "data-testid": e,
    children: t,
    className: r,
    color: s,
    id: n,
    o2Ref: p,
    size: a,
    slot: d,
    style: o
  } = v, m = L(v, [
    "data-testid",
    "children",
    "className",
    "color",
    "id",
    "o2Ref",
    "size",
    "slot",
    "style"
  ]);
  const { styleProps: x } = B(m), c = G(x), l = E();
  return M(
    p,
    () => l.current ? l.current : void 0,
    []
  ), /* @__PURE__ */ y.jsx(
    "o2-badge",
    {
      ref: l,
      id: n,
      "data-testid": e,
      class: A(r, c),
      slot: d,
      style: o,
      color: s,
      size: a,
      children: t
    }
  );
}, It = (l) => {
  var N = l, {
    "data-o2-id": e,
    "data-testid": t,
    background: r = "transparent",
    border: s,
    children: n,
    className: p,
    heading: a,
    id: d,
    imageUrl: o = "",
    o2Ref: m,
    slot: u,
    style: v,
    role: x
  } = N, c = L(N, [
    "data-o2-id",
    "data-testid",
    "background",
    "border",
    "children",
    "className",
    "heading",
    "id",
    "imageUrl",
    "o2Ref",
    "slot",
    "style",
    "role"
  ]);
  const { styleProps: w } = B(c), g = G(w), b = E();
  return M(
    m,
    () => b.current ? b.current : void 0,
    []
  ), /* @__PURE__ */ y.jsx(
    "o2-box",
    {
      ref: b,
      id: d,
      "data-testid": t,
      class: A(p, g),
      heading: a,
      background: r,
      border: h(s),
      "image-url": o,
      slot: u,
      style: v,
      "data-o2-id": e,
      role: x,
      children: n
    }
  );
}, Zt = (k) => {
  var Q = k, {
    "data-image": e,
    "data-o2-id": t,
    "data-o2-reporting": r,
    "data-o2-role": s,
    "data-testid": n,
    children: p,
    className: a,
    disabled: d,
    download: o,
    fullwidth: m,
    href: u,
    icon: v,
    id: x,
    name: c,
    o2Ref: l,
    onClick: N,
    onRef: w,
    rel: g,
    slot: b,
    style: f,
    target: P,
    type: i = "button",
    usage: j = "filled",
    variant: R = "primary"
  } = Q, q = L(Q, [
    "data-image",
    "data-o2-id",
    "data-o2-reporting",
    "data-o2-role",
    "data-testid",
    "children",
    "className",
    "disabled",
    "download",
    "fullwidth",
    "href",
    "icon",
    "id",
    "name",
    "o2Ref",
    "onClick",
    "onRef",
    "rel",
    "slot",
    "style",
    "target",
    "type",
    "usage",
    "variant"
  ]);
  const { styleProps: Z, other: W } = B(q), S = G(Z), X = E(null), K = E();
  M(
    l,
    () => K.current ? K.current : void 0,
    []
  ), tt({
    elementRef: K,
    onRef: w
  }), C(() => {
    if (!n)
      throw new Error('Button component requires "data-testid" attribute.');
    if (!s && i === "submit")
      throw new Error(
        'Button component requires "data-o2-role" attribute ("action-submit" for buttons submitting forms, "action-cancel" for buttons cancelling form submission or back buttons, "action-postpone" for buttons postponing activity).'
      );
  }, [n, s, i]);
  const V = D(
    (Y) => {
      var H;
      if ((N || i === "submit") && Y.preventDefault(), !d) {
        if (i === "submit")
          return (H = X == null ? void 0 : X.current) == null ? void 0 : H.click();
        N == null || N(Y);
      }
    },
    [X, N, i, d]
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    i === "submit" && /* @__PURE__ */ y.jsx(
      "button",
      {
        ref: X,
        type: i,
        id: x,
        "data-testid": n,
        className: "d-none",
        name: c,
        disabled: d,
        "data-o2-id": t,
        "data-o2-role": s,
        "data-o2-reporting": r,
        "data-image": e,
        slot: b,
        style: f
      }
    ),
    /* @__PURE__ */ y.jsx(
      "o2-button",
      wt(xt({
        role: "button",
        ref: K,
        id: x,
        "data-testid": n,
        class: A(a, S),
        "data-o2-id": t,
        "data-o2-role": s,
        "data-o2-reporting": r,
        "data-image": e,
        "full-width": h(m),
        disabled: h(d),
        name: c,
        download: o,
        href: u,
        rel: g,
        target: P,
        type: i,
        onClick: V,
        slot: b,
        style: f,
        usage: j,
        variant: R,
        icon: v
      }, W), {
        children: p
      })
    )
  ] });
}, Tt = (l) => {
  var N = l, {
    "data-o2-id": e,
    "data-testid": t,
    className: r,
    ctaButtonText: s = Yt.ctaButtonText,
    emitter: n,
    id: p,
    images: a,
    o2Ref: d,
    onCtaClick: o,
    onImageDetailClick: m,
    slot: u,
    style: v,
    thumbSlidesPerView: x = 6
  } = N, c = L(N, [
    "data-o2-id",
    "data-testid",
    "className",
    "ctaButtonText",
    "emitter",
    "id",
    "images",
    "o2Ref",
    "onCtaClick",
    "onImageDetailClick",
    "slot",
    "style",
    "thumbSlidesPerView"
  ]);
  const { styleProps: w } = B(c), g = G(w), b = E(), f = Mt(a);
  M(
    d,
    () => b.current ? b.current : void 0,
    []
  );
  const P = D(
    (i) => {
      const j = _("o2ImageDetailClick", {
        value: i.detail.index
      });
      m == null || m(j);
    },
    [m]
  );
  return C(() => {
    ht(void 0, null, function* () {
      var i;
      Array.isArray(a) && Array.isArray(f) && Xt(a, f) || (yield customElements.whenDefined("o2-carousel"), yield (i = b.current) == null ? void 0 : i.setImages(
        a
      ));
    });
  }, [n, P, a, b, f]), J({
    elementRef: b,
    eventName: "o2ImageDetailClick",
    eventCallback: P,
    emitter: n
  }), C(() => {
    if (!t)
      throw new Error(
        'Carousel component requires "data-testid" attribute which is passed to o2-button web component.'
      );
  }, [t]), /* @__PURE__ */ y.jsx(
    "o2-carousel",
    {
      ref: b,
      id: p,
      "data-testid": t,
      class: A(r, g),
      "cta-button": a.length > x,
      "thumb-slides-per-view": x,
      slot: u,
      style: v,
      children: a.length > x && /* @__PURE__ */ y.jsx(
        Zt,
        {
          name: e + "-cta",
          slot: "cta",
          id: p + "-cta",
          "data-o2-id": e + "-cta",
          "data-testid": t + "-cta",
          usage: "ghost",
          onClick: o,
          children: s
        }
      )
    }
  );
}, te = (i) => {
  var j = i, {
    "data-o2-id": e,
    "data-o2-reporting": t,
    "data-testid": r,
    checked: s,
    children: n,
    className: p,
    disabled: a,
    emitter: d,
    id: o,
    indeterminate: m,
    multiple: u,
    name: v,
    o2Ref: x,
    onBlur: c,
    onChange: l,
    onRef: N,
    required: w,
    slot: g,
    style: b,
    value: f
  } = j, P = L(j, [
    "data-o2-id",
    "data-o2-reporting",
    "data-testid",
    "checked",
    "children",
    "className",
    "disabled",
    "emitter",
    "id",
    "indeterminate",
    "multiple",
    "name",
    "o2Ref",
    "onBlur",
    "onChange",
    "onRef",
    "required",
    "slot",
    "style",
    "value"
  ]);
  const { styleProps: R } = B(P), q = G(R), k = E();
  M(
    x,
    () => k.current ? k.current : void 0,
    []
  );
  const { fieldName: Q, onFieldChange: Z, onFieldBlur: W, fieldValue: S } = nt(v, "default"), X = D(
    (Y, H = []) => Y ? [...H, f] : H.filter((rt) => rt !== f),
    [f]
  );
  C(() => {
    k != null && k.current && u && (k.current.fieldValue = S);
  }, [S, u]);
  const K = D(
    (Y) => {
      const H = u ? X(
        Y.detail.value,
        Y.target.fieldValue
      ) : Y.detail.value, rt = _("o2Change", {
        value: H,
        name: v
      });
      Z == null || Z(rt), l == null || l(rt);
    },
    [u, X, v, Z, l]
  ), V = D(() => {
    const Y = _("o2Blur", {
      name: v
    });
    W == null || W(Y), c == null || c(Y);
  }, [v, c, W]);
  return J({
    elementRef: k,
    eventName: "o2Change",
    eventCallback: K,
    emitter: d
  }), J({
    elementRef: k,
    eventName: "o2Blur",
    eventCallback: V,
    emitter: d
  }), tt({
    elementRef: k,
    onRef: N
  }), C(() => {
    if (!r)
      throw new Error('Checkbox component requires "data-testid" attribute.');
  }, [r]), /* @__PURE__ */ y.jsx(
    "o2-checkbox",
    {
      ref: k,
      value: f,
      name: Q,
      checked: h(s),
      indeterminate: h(m),
      disabled: h(a),
      id: o,
      "data-testid": r,
      class: A(p, q),
      "data-o2-id": e,
      "data-o2-reporting": t,
      required: h(w),
      slot: g,
      style: b,
      children: n
    }
  );
}, $t = (x) => {
  var c = x, {
    "data-testid": e,
    children: t,
    className: r,
    disabled: s,
    error: n,
    id: p,
    o2Ref: a,
    readonly: d,
    slot: o,
    style: m,
    warning: u
  } = c, v = L(c, [
    "data-testid",
    "children",
    "className",
    "disabled",
    "error",
    "id",
    "o2Ref",
    "readonly",
    "slot",
    "style",
    "warning"
  ]);
  const { styleProps: l } = B(v), N = G(l), w = E();
  return M(
    a,
    () => w.current ? w.current : void 0,
    []
  ), /* @__PURE__ */ y.jsx(
    "o2-form-field",
    {
      ref: w,
      id: p,
      "data-testid": e,
      class: A(r, N),
      error: h(n),
      warning: h(u),
      disabled: h(s),
      readonly: h(d),
      slot: o,
      style: m,
      children: t
    }
  );
}, ee = (N) => {
  var w = N, {
    "data-testid": e,
    borderColor: t,
    borderLeft: r,
    children: s,
    className: n,
    disabled: p,
    heading: a,
    headingRight: d,
    id: o,
    o2Ref: m,
    open: u,
    slot: v,
    style: x,
    type: c
  } = w, l = L(w, [
    "data-testid",
    "borderColor",
    "borderLeft",
    "children",
    "className",
    "disabled",
    "heading",
    "headingRight",
    "id",
    "o2Ref",
    "open",
    "slot",
    "style",
    "type"
  ]);
  const { styleProps: g } = B(l), b = G(g), f = E();
  return M(
    m,
    () => f.current ? f.current : void 0,
    []
  ), /* @__PURE__ */ y.jsx(
    "o2-dropdown",
    {
      ref: f,
      id: o,
      "data-testid": e,
      class: A(n, b),
      type: c,
      heading: a,
      "heading-right": d,
      open: h(u),
      "border-left": h(r),
      "border-color": t,
      disabled: h(p),
      slot: v,
      style: x,
      children: s
    }
  );
}, _t = (b) => {
  var f = b, {
    "data-o2-id": e,
    "data-o2-reporting": t,
    "data-testid": r,
    className: s,
    color: n,
    id: p,
    name: a,
    o2Ref: d,
    onClick: o,
    onRef: m,
    safeArea: u,
    size: v,
    solid: x,
    slot: c,
    src: l,
    style: N,
    role: w
  } = f, g = L(f, [
    "data-o2-id",
    "data-o2-reporting",
    "data-testid",
    "className",
    "color",
    "id",
    "name",
    "o2Ref",
    "onClick",
    "onRef",
    "safeArea",
    "size",
    "solid",
    "slot",
    "src",
    "style",
    "role"
  ]);
  const { styleProps: P } = B(g), i = G(P), j = E();
  return M(
    d,
    () => j.current ? j.current : void 0,
    []
  ), C(() => {
    if (!a && !l)
      throw new Error('Icon component requires either "name" or "src" attribute.');
  }, [a, l]), tt({
    elementRef: j,
    onRef: m
  }), /* @__PURE__ */ y.jsx(
    "o2-icon",
    {
      ref: j,
      id: p,
      "data-testid": r,
      "data-o2-id": e,
      "data-o2-reporting": t,
      class: A(a === "loading" && "o2-animation-rotate", s, i),
      color: n,
      name: a,
      src: l,
      size: v,
      solid: x,
      slot: c,
      style: N,
      onClick: o,
      "safe-area": u,
      role: w
    }
  );
}, Ct = (g) => {
  var b = g, {
    "data-testid": e,
    children: t,
    className: r,
    color: s = "default",
    content: n = "",
    disabled: p,
    htmlFor: a = "",
    id: d,
    o2Ref: o,
    offsetX: m,
    offsetY: u,
    onRef: v,
    open: x,
    placement: c = "top",
    slot: l,
    style: N
  } = b, w = L(b, [
    "data-testid",
    "children",
    "className",
    "color",
    "content",
    "disabled",
    "htmlFor",
    "id",
    "o2Ref",
    "offsetX",
    "offsetY",
    "onRef",
    "open",
    "placement",
    "slot",
    "style"
  ]);
  const { styleProps: f } = B(w), P = G(f), i = E();
  return M(
    o,
    () => i.current ? i.current : void 0,
    []
  ), C(() => {
    var j, R;
    i != null && i.current && n && ((R = (j = i.current).setContent) == null || R.call(j, n));
  }, [i, n]), tt({
    elementRef: i,
    onRef: v
  }), /* @__PURE__ */ y.jsx(
    "o2-tooltip",
    {
      ref: i,
      id: d,
      "data-testid": e,
      class: A(r, P),
      for: a,
      color: s,
      content: n,
      disabled: h(p),
      "offset-x": m,
      "offset-y": u,
      open: h(x),
      placement: c,
      slot: l,
      style: N,
      children: t
    },
    `${a}-${p ? "disabled" : "enabled"}`
  );
}, Lt = {
  default: "question-circle",
  warning: "exclamation-triangle",
  danger: "exclamation-circle"
}, Bt = {
  default: "gray-light",
  warning: "orange",
  danger: "red"
}, Kt = ({
  "data-testid": e,
  color: t = "default",
  help: r = !1,
  name: s,
  tooltip: n = !1,
  tooltipContent: p,
  tooltipPopover: a
}) => {
  var x, c;
  const { fieldColor: d, fieldTooltip: o, fieldError: m, error: u } = nt(s, t, n), v = Gt(() => window.btoa(s).replace(/=/g, ""), [s]);
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsxs("span", { slot: "tooltip", style: { display: o ? "inline-block" : "none" }, children: [
      /* @__PURE__ */ y.jsx("span", { id: v, "data-testid": e, children: /* @__PURE__ */ y.jsx(
        _t,
        {
          solid: !0,
          name: (x = Lt[d]) != null ? x : Lt.default,
          color: (c = Bt[d]) != null ? c : Bt.default
        }
      ) }),
      !m && a && /* @__PURE__ */ y.jsx(Ct, { htmlFor: v, content: a, placement: "bottom", color: "default", disabled: !1 })
    ] }),
    /* @__PURE__ */ y.jsx("span", { slot: "help-text", style: { display: o || r ? "inline-block" : "none" }, children: m ? u : p })
  ] });
}, re = (m) => {
  var u = m, {
    "data-testid": e,
    className: t,
    heading: r,
    id: s,
    images: n,
    o2Ref: p,
    slot: a,
    style: d
  } = u, o = L(u, [
    "data-testid",
    "className",
    "heading",
    "id",
    "images",
    "o2Ref",
    "slot",
    "style"
  ]);
  const { styleProps: v } = B(o), x = G(v), c = E();
  return M(
    p,
    () => c.current ? c.current : void 0,
    []
  ), C(() => {
    ht(void 0, null, function* () {
      var l;
      yield customElements.whenDefined("o2-gallery"), yield (l = c == null ? void 0 : c.current) == null ? void 0 : l.setImages(
        n
      );
    });
  }, [c, n]), /* @__PURE__ */ y.jsx(
    "o2-gallery",
    {
      ref: c,
      heading: r,
      id: s,
      "data-testid": e,
      class: A(t, x),
      slot: a,
      style: d
    }
  );
}, se = (R) => {
  var q = R, {
    "data-image": e,
    "data-o2-id": t,
    "data-o2-reporting": r,
    "data-o2-role": s,
    "data-testid": n,
    children: p,
    className: a,
    disabled: d,
    download: o,
    href: m,
    icon: u,
    id: v,
    name: x,
    o2Ref: c,
    onClick: l,
    rel: N,
    slot: w,
    style: g,
    target: b,
    type: f = "button",
    usage: P = "filled",
    variant: i = "primary"
  } = q, j = L(q, [
    "data-image",
    "data-o2-id",
    "data-o2-reporting",
    "data-o2-role",
    "data-testid",
    "children",
    "className",
    "disabled",
    "download",
    "href",
    "icon",
    "id",
    "name",
    "o2Ref",
    "onClick",
    "rel",
    "slot",
    "style",
    "target",
    "type",
    "usage",
    "variant"
  ]);
  const { styleProps: k, other: Q } = B(j), Z = G(k), W = E(null), S = E();
  M(
    c,
    () => S.current ? S.current : void 0,
    []
  ), C(() => {
    if (!n)
      throw new Error('Icon button component requires "data-testid" attribute.');
    if (!s && f === "submit")
      throw new Error(
        'Icon button component requires "data-o2-role" attribute ("action-submit" for buttons submitting forms, "action-cancel" for buttons cancelling form submission or back buttons, "action-postpone" for buttons postponing activity).'
      );
  }, [n, s, f]);
  const X = D(
    (K) => {
      var V;
      if ((l || f === "submit") && K.preventDefault(), !d) {
        if (f === "submit")
          return (V = W == null ? void 0 : W.current) == null ? void 0 : V.click();
        l == null || l(K);
      }
    },
    [W, l, f, d]
  );
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    f === "submit" && /* @__PURE__ */ y.jsx(
      "button",
      {
        ref: W,
        type: f,
        id: v,
        "data-testid": n,
        className: "d-none",
        name: x,
        disabled: d,
        "data-o2-id": t,
        "data-o2-role": s,
        "data-o2-reporting": r,
        "data-image": e,
        slot: w,
        style: g
      }
    ),
    /* @__PURE__ */ y.jsx(
      "o2-icon-button",
      wt(xt({
        role: "button",
        ref: S,
        id: v,
        "data-testid": n,
        class: A(a, Z),
        "data-o2-id": t,
        "data-o2-role": s,
        "data-o2-reporting": r,
        "data-image": e,
        disabled: h(d),
        name: x,
        download: o,
        href: m,
        rel: N,
        target: b,
        type: f,
        onClick: X,
        slot: w,
        style: g,
        usage: P,
        variant: i,
        icon: u
      }, Q), {
        children: p
      })
    )
  ] });
}, oe = (Pt) => {
  var st = Pt, {
    "data-o2-id": e,
    "data-testid": t,
    autocapitalize: r = "off",
    autocomplete: s = "off",
    autocorrect: n = "off",
    autofocus: p,
    children: a,
    className: d,
    color: o = "default",
    disabled: m,
    emitter: u,
    formFieldClassName: v,
    help: x,
    id: c,
    inputmode: l,
    label: N,
    leadingIcon: w,
    max: g,
    maxLength: b,
    min: f,
    minLength: P,
    name: i,
    o2Ref: j,
    onBlur: R,
    onChange: q,
    onFocus: k,
    onInput: Q,
    onKeyUp: Z,
    onRef: W,
    placeholder: S,
    readonly: X,
    required: K,
    showRequirementText: V,
    slot: Y,
    step: H,
    style: rt,
    styleFormField: ft,
    type: yt = "text",
    value: Nt = ""
  } = st, F = L(st, [
    "data-o2-id",
    "data-testid",
    "autocapitalize",
    "autocomplete",
    "autocorrect",
    "autofocus",
    "children",
    "className",
    "color",
    "disabled",
    "emitter",
    "formFieldClassName",
    "help",
    "id",
    "inputmode",
    "label",
    "leadingIcon",
    "max",
    "maxLength",
    "min",
    "minLength",
    "name",
    "o2Ref",
    "onBlur",
    "onChange",
    "onFocus",
    "onInput",
    "onKeyUp",
    "onRef",
    "placeholder",
    "readonly",
    "required",
    "showRequirementText",
    "slot",
    "step",
    "style",
    "styleFormField",
    "type",
    "value"
  ]);
  const { styleProps: dt } = B(F), ct = G(dt), U = E();
  M(
    j,
    () => U.current ? U.current : void 0,
    []
  );
  const { fieldError: it, error: pt, fieldName: gt, fieldValue: O, iconColor: lt, onFieldChange: I, onFieldBlur: ot } = nt(
    i,
    o
  ), ut = Gt(() => it ? pt : x, [it, pt, x]), $ = D(
    (T) => {
      const et = _("o2Input", {
        value: T.detail.target.value,
        name: i
      });
      I == null || I(et), Q == null || Q(et), q == null || q(et);
    },
    [i, Q, q, I]
  ), z = D(
    (T) => {
      var Rt, kt;
      const et = (kt = (Rt = T == null ? void 0 : T.target) == null ? void 0 : Rt.value) != null ? kt : "", jt = O ? O.trim() : et.trim(), zt = O ? O === jt : et === jt, vt = _("o2Blur", {
        value: jt,
        name: i
      });
      ot == null || ot(vt), R == null || R(vt), zt || (I == null || I(vt), q == null || q(vt));
    },
    [O, i, ot, R, I, q]
  ), mt = D(
    (T) => {
      const et = _("o2KeyUp", {
        value: T.detail.key,
        name: i
      });
      Z == null || Z(et);
    },
    [i, Z]
  ), at = D(() => {
    const T = _("o2Focus", {
      name: i
    });
    k == null || k(T);
  }, [i, k]);
  return C(() => {
    if (!t)
      throw new Error('Input component requires "data-testid" attribute which is passed to o2-input web component.');
  }, [t]), J({
    elementRef: U,
    eventName: "o2Focus",
    eventCallback: at,
    emitter: u
  }), J({
    elementRef: U,
    eventName: "o2Input",
    eventCallback: $,
    emitter: u
  }), J({
    elementRef: U,
    eventName: "o2Blur",
    eventCallback: z,
    emitter: u
  }), J({
    elementRef: U,
    eventName: "o2Keyup",
    eventCallback: mt,
    emitter: u
  }), tt({
    elementRef: U,
    onRef: W
  }), /* @__PURE__ */ y.jsxs(
    $t,
    {
      disabled: m,
      readonly: X,
      error: lt === "red",
      warning: lt === "orange",
      slot: Y,
      className: A(v),
      style: ft,
      children: [
        /* @__PURE__ */ y.jsx(
          "o2-input",
          {
            ref: U,
            autocapitalize: r,
            "show-requirement-text": V,
            autocomplete: s,
            autocorrect: n,
            autofocus: h(p),
            disabled: h(m),
            inputmode: l,
            min: f,
            max: g,
            name: gt,
            placeholder: S,
            readonly: h(X),
            required: h(K),
            step: H,
            type: yt,
            value: O != null ? O : Nt,
            label: N,
            "data-o2-id": e,
            id: c,
            "data-testid": t,
            class: A(d, ct),
            warning: h(lt === "orange"),
            error: h(lt === "red"),
            "leading-icon": w,
            minlength: P,
            maxlength: b,
            style: rt,
            children: a
          }
        ),
        /* @__PURE__ */ y.jsx("span", { slot: "help-text", style: { display: ut ? "inline-block" : "none" }, children: ut })
      ]
    }
  );
}, ae = (x) => {
  var c = x, {
    "data-testid": e,
    children: t,
    className: r,
    emitter: s,
    id: n,
    o2Ref: p,
    onHide: a,
    onRef: d,
    onShow: o,
    slot: m,
    style: u
  } = c, v = L(c, [
    "data-testid",
    "children",
    "className",
    "emitter",
    "id",
    "o2Ref",
    "onHide",
    "onRef",
    "onShow",
    "slot",
    "style"
  ]);
  const { styleProps: l } = B(v), N = G(l), w = E();
  M(
    p,
    () => w.current ? w.current : void 0,
    []
  );
  const g = D(() => {
    a == null || a();
  }, [a]), b = D(() => {
    o == null || o();
  }, [o]);
  return J({
    elementRef: w,
    eventName: "o2Hide",
    eventCallback: g,
    emitter: s
  }), J({
    elementRef: w,
    eventName: "o2Show",
    eventCallback: b,
    emitter: s
  }), tt({
    elementRef: w,
    onRef: d
  }), /* @__PURE__ */ y.jsx(
    "o2-loader",
    {
      ref: w,
      id: n,
      "data-testid": e,
      class: A(r, N),
      slot: m,
      style: u,
      children: t
    }
  );
}, ne = (N) => {
  var w = N, {
    "data-testid": e,
    alt: t,
    className: r,
    height: s,
    id: n,
    loading: p,
    o2Ref: a,
    sizes: d,
    skipWebp: o,
    slot: m,
    src: u,
    srcset: v,
    style: x,
    width: c
  } = w, l = L(w, [
    "data-testid",
    "alt",
    "className",
    "height",
    "id",
    "loading",
    "o2Ref",
    "sizes",
    "skipWebp",
    "slot",
    "src",
    "srcset",
    "style",
    "width"
  ]);
  const { styleProps: g } = B(l), b = G(g), f = E();
  return M(
    a,
    () => f.current ? f.current : void 0,
    []
  ), /* @__PURE__ */ y.jsx(
    "o2-picture",
    {
      ref: f,
      id: n,
      "data-testid": e,
      class: A(r, b),
      src: u,
      srcset: v,
      sizes: d,
      alt: t,
      width: c,
      height: s,
      "skip-webp": h(o),
      loading: p,
      slot: m,
      style: x
    }
  );
}, ce = (g) => {
  var b = g, {
    "data-o2-id": e,
    "data-testid": t,
    children: r,
    className: s,
    disabled: n,
    emitter: p,
    id: a,
    label: d,
    name: o,
    o2Ref: m,
    onChange: u,
    onRef: v,
    required: x,
    slot: c,
    style: l,
    value: N
  } = b, w = L(b, [
    "data-o2-id",
    "data-testid",
    "children",
    "className",
    "disabled",
    "emitter",
    "id",
    "label",
    "name",
    "o2Ref",
    "onChange",
    "onRef",
    "required",
    "slot",
    "style",
    "value"
  ]);
  const { styleProps: f } = B(w), P = G(f), i = E();
  M(
    m,
    () => i.current ? i.current : void 0,
    []
  );
  const { fieldName: j, onFieldChange: R } = nt(o, "default"), q = D(
    (k) => {
      const Q = _("o2Change", {
        value: k.detail.value,
        name: o
      });
      R == null || R(Q), u == null || u(Q);
    },
    [o, u, R]
  );
  return J({
    elementRef: i,
    eventName: "o2Change",
    eventCallback: q,
    emitter: p
  }), tt({
    elementRef: i,
    onRef: v
  }), C(() => {
    if (!t)
      throw new Error('RadioGroup component requires "data-testid" attribute.');
  }, [t]), /* @__PURE__ */ y.jsxs(
    "o2-radio-group",
    {
      ref: i,
      value: N,
      name: j,
      disabled: h(n),
      required: h(x, !0),
      id: a,
      "data-testid": t,
      class: A(s, P),
      "data-o2-id": e,
      slot: c,
      style: l,
      children: [
        d ? /* @__PURE__ */ y.jsx("label", { className: "text-caption", style: { flexBasis: "100%" }, children: d }) : null,
        r
      ]
    }
  );
}, ie = (w) => {
  var g = w, {
    "data-o2-id": e,
    "data-testid": t,
    checked: r,
    children: s,
    className: n,
    disabled: p,
    emitter: a,
    id: d,
    name: o,
    o2Ref: m,
    onRadioChange: u,
    onRef: v,
    slot: x,
    style: c,
    value: l
  } = g, N = L(g, [
    "data-o2-id",
    "data-testid",
    "checked",
    "children",
    "className",
    "disabled",
    "emitter",
    "id",
    "name",
    "o2Ref",
    "onRadioChange",
    "onRef",
    "slot",
    "style",
    "value"
  ]);
  const { styleProps: b } = B(N), f = G(b), P = E();
  M(
    m,
    () => P.current ? P.current : void 0,
    []
  );
  const { onFieldChange: i } = nt(o, "default"), j = D(
    (R) => {
      const q = _("o2RadioChange", {
        value: R.detail.value,
        name: o
      });
      i == null || i(q), u == null || u(q);
    },
    [o, i, u]
  );
  return J({
    elementRef: P,
    eventName: "o2RadioChange",
    eventCallback: j,
    emitter: a
  }), tt({
    elementRef: P,
    onRef: v
  }), C(() => {
    if (!t)
      throw new Error('Radio component requires "data-testid" attribute.');
  }, [t]), /* @__PURE__ */ y.jsx(
    "o2-radio",
    {
      ref: P,
      value: l,
      checked: h(r),
      disabled: h(p),
      id: d,
      "data-testid": t,
      class: A(n, f),
      "data-o2-id": e,
      slot: x,
      style: c,
      children: s
    }
  );
}, le = (rt) => {
  var ft = rt, {
    "data-o2-id": e,
    "data-testid": t,
    allowDeselect: r,
    className: s,
    color: n = "default",
    dataOptions: p,
    disabled: a,
    dynamicSearch: d,
    emitter: o,
    error: m,
    formFieldClassName: u,
    id: v,
    label: x,
    multiple: c,
    name: l,
    native: N,
    o2Ref: w,
    onChange: g,
    onClose: b,
    onOpen: f,
    onScrollToEnd: P,
    onSearch: i,
    placeholder: j,
    readonly: R,
    search: q,
    searchPlaceholder: k,
    searchText: Q,
    showRequirementText: Z,
    slot: W,
    style: S,
    tooltip: X,
    tooltipContent: K,
    tooltipPopover: V,
    value: Y
  } = ft, H = L(ft, [
    "data-o2-id",
    "data-testid",
    "allowDeselect",
    "className",
    "color",
    "dataOptions",
    "disabled",
    "dynamicSearch",
    "emitter",
    "error",
    "formFieldClassName",
    "id",
    "label",
    "multiple",
    "name",
    "native",
    "o2Ref",
    "onChange",
    "onClose",
    "onOpen",
    "onScrollToEnd",
    "onSearch",
    "placeholder",
    "readonly",
    "search",
    "searchPlaceholder",
    "searchText",
    "showRequirementText",
    "slot",
    "style",
    "tooltip",
    "tooltipContent",
    "tooltipPopover",
    "value"
  ]);
  const { styleProps: yt } = B(H), Nt = G(yt), F = E();
  M(
    w,
    () => F.current ? F.current : void 0,
    []
  );
  const { fieldName: Pt, fieldValue: st, fieldColor: dt, onFieldChange: ct, onFieldBlur: U } = nt(l, n, X), it = E(!1), pt = D(
    ($) => {
      let z;
      if (c)
        z = $.detail.flatMap(
          (at) => at.value === "undefined" ? [] : [at.value]
        );
      else {
        const at = $.detail.value;
        z = at === "undefined" ? void 0 : at;
      }
      const mt = _("o2Change", {
        value: z,
        name: l
      });
      g == null || g(mt), ct == null || ct(mt);
    },
    [c, l, g, ct]
  ), gt = D(() => {
    const $ = _("o2Close", {
      name: l
    });
    b == null || b($), U == null || U($);
  }, [l, b, U]), O = D(
    ($) => {
      const z = _("o2Search", {
        name: l,
        value: $.detail
      });
      i == null || i(z);
    },
    [l, i]
  ), lt = D(() => {
    const $ = _("o2Open", {
      name: l
    });
    f == null || f($);
  }, [l, f]), I = D(
    ($) => {
      const z = _("o2ScrollToEnd", {
        name: l,
        value: $.detail
      });
      P == null || P(z);
    },
    [l, P]
  ), ot = D(
    ($, z) => c ? !!(z != null && z.length && z.indexOf($.value) !== -1) : Dt(z, $.value),
    [c]
  ), ut = Mt(p);
  return C(() => {
    if (!t)
      throw new Error(
        'SelectPicker component requires "data-testid" attribute which is passed to o2-select web component.'
      );
  }, [t]), C(() => {
    ht(void 0, null, function* () {
      var $;
      Dt(ut, p) || (yield customElements.whenDefined("o2-select"), yield ($ = F == null ? void 0 : F.current) == null ? void 0 : $.setData(
        p != null && p.length ? p == null ? void 0 : p.map((z) => wt(xt({}, z), {
          selected: ot(z, st != null ? st : Y)
        })) : [],
        d && it.current
      ), it.current = !0);
    });
  }, [p, it, d, st, ut, ot, Y]), J({
    elementRef: F,
    eventName: "o2Change",
    eventCallback: pt,
    emitter: o
  }), J({
    elementRef: F,
    eventName: "o2Close",
    eventCallback: gt,
    emitter: o
  }), J({
    elementRef: F,
    eventName: "o2Search",
    eventCallback: O,
    emitter: o
  }), J({
    elementRef: F,
    eventName: "o2Open",
    eventCallback: lt,
    emitter: o
  }), J({
    elementRef: F,
    eventName: "o2ScrollToEnd",
    eventCallback: I,
    emitter: o
  }), /* @__PURE__ */ y.jsxs(
    $t,
    {
      disabled: a,
      readonly: R,
      error: dt === "danger",
      warning: dt === "warning",
      slot: W,
      className: A(u),
      style: S,
      children: [
        /* @__PURE__ */ y.jsx(
          "o2-select",
          {
            ref: F,
            id: v,
            "data-testid": t,
            "show-requirement-text": Z,
            class: A(s, Nt),
            "dynamic-search": h(d),
            "allow-deselect": h(r),
            "data-o2-id": e,
            disabled: h(a),
            readonly: h(R),
            label: x,
            multiple: h(c),
            name: Pt,
            native: h(N),
            placeholder: j,
            search: h(q),
            "search-placeholder": k,
            "search-text": Q,
            error: h(m != null ? m : dt === "danger")
          }
        ),
        /* @__PURE__ */ y.jsx(
          Kt,
          {
            name: l,
            color: n,
            tooltip: X,
            tooltipContent: K,
            tooltipPopover: V
          }
        )
      ]
    }
  );
}, de = (l) => {
  var N = l, {
    "data-testid": e,
    className: t,
    color: r,
    disabled: s,
    id: n,
    o2Ref: p,
    onClick: a,
    onRef: d,
    shape: o = "circle",
    size: m,
    slot: u,
    style: v,
    tooltip: x
  } = N, c = L(N, [
    "data-testid",
    "className",
    "color",
    "disabled",
    "id",
    "o2Ref",
    "onClick",
    "onRef",
    "shape",
    "size",
    "slot",
    "style",
    "tooltip"
  ]);
  const { styleProps: w } = B(c), g = G(w), b = E();
  return M(
    p,
    () => b.current ? b.current : void 0,
    []
  ), tt({
    elementRef: b,
    onRef: d
  }), x ? /* @__PURE__ */ y.jsx(Ct, { content: x, slot: u, children: /* @__PURE__ */ y.jsx("span", { children: /* @__PURE__ */ y.jsx(
    "o2-status",
    {
      ref: b,
      id: n,
      "data-testid": e,
      class: A(t, g),
      color: r,
      size: m,
      shape: o,
      disabled: h(s),
      style: v,
      onClick: (f) => !s && (a == null ? void 0 : a(f))
    }
  ) }) }) : /* @__PURE__ */ y.jsx(
    "o2-status",
    {
      ref: b,
      id: n,
      "data-testid": e,
      class: A(t, g),
      color: r,
      size: m,
      shape: o,
      disabled: h(s),
      slot: u,
      style: v,
      onClick: (f) => !s && (a == null ? void 0 : a(f))
    }
  );
}, ue = (N) => {
  var w = N, {
    "data-o2-id": e,
    "data-testid": t,
    checked: r,
    children: s,
    className: n,
    disabled: p,
    emitter: a,
    id: d,
    name: o,
    o2Ref: m,
    onChange: u,
    slot: v,
    style: x,
    value: c
  } = w, l = L(w, [
    "data-o2-id",
    "data-testid",
    "checked",
    "children",
    "className",
    "disabled",
    "emitter",
    "id",
    "name",
    "o2Ref",
    "onChange",
    "slot",
    "style",
    "value"
  ]);
  const { styleProps: g } = B(l), b = G(g), f = E();
  M(
    m,
    () => f.current ? f.current : void 0,
    []
  );
  const { fieldName: P, onFieldChange: i, onFieldBlur: j } = nt(o, "default"), R = D(
    (q) => {
      const k = _("o2Change", {
        value: q.detail.value,
        name: o
      });
      u == null || u(k), i == null || i(k), setTimeout(() => {
        j == null || j(k);
      });
    },
    [o, u, i, j]
  );
  return J({
    elementRef: f,
    eventName: "o2Change",
    eventCallback: R,
    emitter: a
  }), C(() => {
    if (!t)
      throw new Error('Toggle component requires "data-testid" attribute.');
  }, [t]), /* @__PURE__ */ y.jsx(
    "o2-toggle",
    {
      ref: f,
      value: c,
      name: P,
      checked: h(r),
      disabled: h(p),
      id: d,
      "data-testid": t,
      class: A(n, b),
      "data-o2-id": e,
      slot: v,
      style: x,
      children: s
    }
  );
};
export {
  Vt as A,
  Ot as B,
  Tt as C,
  ee as D,
  $t as F,
  re as G,
  se as I,
  ae as L,
  ne as P,
  ce as R,
  le as S,
  ue as T,
  tt as a,
  Mt as b,
  Kt as c,
  It as d,
  Zt as e,
  te as f,
  _t as g,
  oe as h,
  ie as i,
  de as j,
  Ct as k,
  h as p,
  J as u
};
//# sourceMappingURL=toggle-5d5ed848.js.map
